// KWD is a three-decimal (fils) currency — always display 3 decimals.

export type Lang = "en" | "ar";

/** Format a KWD amount as "1.750 KWD" / "1.750 د.ك". */
export function formatKWD(amount: number, lang: Lang = "en"): string {
  const value = (amount ?? 0).toFixed(3);
  return lang === "ar" ? `${toArabicDigits(value)} د.ك` : `${value} KWD`;
}

/** Bare 3-decimal number, no currency label. */
export function money(amount: number): string {
  return (amount ?? 0).toFixed(3);
}

const AR_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

/** Convert Latin digits in a string to Arabic-Indic digits. */
export function toArabicDigits(s: string): string {
  return s.replace(/[0-9]/g, (d) => AR_DIGITS[Number(d)]);
}

/** Local YYYY-MM-DD key for a given timezone (defaults to Asia/Kuwait). */
export function dateKey(d: Date = new Date(), timeZone = "Asia/Kuwait"): string {
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}
